import { defineMessages } from 'react-intl';

export default defineMessages({
    renameGroup: {
        id: 'app.components.RenameGroup.renameGroup',
        defaultMessage: 'Rename your group'
    },
    groupNameLabel: {
        id: 'app.components.RenameGroup.groupNameLabel',
        defaultMessage: 'Group Name'
    },
    renameGroupConfirmation: {
        id: 'app.components.RenameGroup.renameGroupConfirmation',
        defaultMessage: 'Your group has been renamed.'
    },
    doYouWishTo: {
        id: 'app.components.RenameGroup.doYouWishTo',
        defaultMessage: 'Do you wish to rename the group'
    },
    to: {
        id: 'app.components.RenameGroup.to',
        defaultMessage: 'to'
    },
    questionMark: {
        id: 'app.components.RenameGroup.questionMark',
        defaultMessage: '?'
    }
});



// WEBPACK FOOTER //
// ./app/components/rename-group/messages.js